import React from 'react';
import PropTypes from 'prop-types';
import FormattedTranslation from 'components/Common/FormattedTranslationMui';
import { Box, Divider, Typography } from '@mui/material';

export const DividerWithText = ({ textId }) => (
  <Box
    alignItems="center"
    display="flex"
    flexDirection="row"
    justifyContent="space-evenly"
  >
    <Divider />
    <Typography variant="body1">
      <FormattedTranslation id={textId} />
    </Typography>
    <Divider />
  </Box>
);

DividerWithText.propTypes = {
  textId: PropTypes.string,
};

DividerWithText.defaultProps = {
  textId: 'general.or',
};

export default DividerWithText;
